// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hypoxia.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hypoxia/hypoxia.js';

mount([g0]);
